import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";

export function StickyMobileCTA({ onOpenDemo }) {
  const { t } = useLanguage();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.6);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
          className="lg:hidden fixed bottom-0 left-0 right-0 z-50 glass-nav border-t border-white/10 px-4 py-3"
          data-testid="sticky-mobile-cta"
        >
          <button
            onClick={onOpenDemo}
            data-testid="sticky-mobile-cta-button"
            className="w-full inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md bg-[#00F0FF] text-black text-sm font-semibold hover:brightness-110 transition-all duration-200"
          >
            {t.site.ctaPrimary}
            <ArrowRight className="w-4 h-4" />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
